import { AlertTriangle, BellRing, CalendarClock } from "lucide-react";
import { money } from "../api";

const GROUPS = [
  ["overdue", "Gecikmiş", "alert-red", AlertTriangle, (d) => `${Math.abs(d)} gün gecikti`],
  ["soon", "7 gün içinde", "alert-amber", BellRing, (d) => (d === 0 ? "Bugün" : `${d} gün kaldı`)],
  ["upcoming", "30 gün içinde", "alert-blue", CalendarClock, (d) => `${d} gün kaldı`],
];

export default function AlertsPanel({ alerts, onOpenProject, compact }) {
  const counts = alerts?.counts || {};
  const total = (counts.overdue || 0) + (counts.soon || 0) + (counts.upcoming || 0);
  return (
    <section className="panel alerts-panel" data-testid="alerts-panel">
      <div className="panel-head">
        <div><span className="eyebrow">ÖDEME VADELERİ</span><h2>Yaklaşan & gecikmiş ödemeler</h2></div>
        <div className="alert-counters">
          {GROUPS.map(([k, label, cls]) => (
            <span key={k} className={`alert-chip ${cls}`} data-testid={`alert-count-${k}`}><b>{counts[k] || 0}</b> {label}</span>
          ))}
        </div>
      </div>
      {!total && <div className="empty-hint" data-testid="alerts-empty">Vadesi yaklaşan veya gecikmiş ödeme yok. Ödemelere vade tarihi girerek uyarı alabilirsiniz.</div>}
      {!!total && (
        <div className="alert-list">
          {GROUPS.map(([k, , cls, Icon, fmt]) => (alerts[k] || []).slice(0, compact ? 3 : 20).map((p) => (
            <div key={p.id} className={`alert-row ${cls} ${p.direction === "incoming" ? "dir-in" : "dir-out"}`} data-testid={`alert-row-${k}`} onClick={() => onOpenProject?.(p.project_id)}>
              <div className="alert-ico"><Icon size={15} /></div>
              <div className="alert-info">
                <b>{p.project_name || "—"}</b>
                <small>
                  <span className={`pay-dir ${p.direction === "incoming" ? "in" : "out"}`}>{p.direction === "incoming" ? "Gelen (Tahsilat)" : "Giden (Ödeme)"}</span>
                  {" · "}{p.direction === "incoming" ? (p.employer_short || "İşveren") : (p.subcontractor_short || "Alt yüklenici")} · {p.stage} · vade {p.due}
                </small>
              </div>
              <strong>{money(p.amount, p.currency)}</strong>
              <em>{fmt(p.days)}</em>
            </div>
          )))}
        </div>
      )}
    </section>
  );
}
